/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import { WINDOW } from '../../helpers/window.injectToken'
import { NewRelicClickData } from './new-relic-types'

export enum PageAction {
  APP_LOADED = 'Profile-AppLoaded',
  BUTTON_CLICK = 'Profile-ButtonClick',
}

interface NewRelicApi {
  addPageAction: (name: string, data: object) => void
  noticeError: (error: Error, data?: object) => void
}

@Injectable({
  providedIn: 'root',
})
export class NewRelicService {
  private readonly window = inject<Window>(WINDOW)

  private get newrelic(): NewRelicApi | undefined {
    return (this.window as unknown as Record<string, unknown>)['newrelic'] as NewRelicApi | undefined
  }

  addPageLoadAction(country: string) {
    if (this.newrelic) {
      this.newrelic.addPageAction(PageAction.APP_LOADED, {
        timestamp: new Date().toISOString(),
        appCountry: country,
      })
    }
  }

  addClickAction(clickAction: NewRelicClickData) {
    if (this.newrelic) {
      this.newrelic.addPageAction(clickAction.elementType ?? PageAction.BUTTON_CLICK, {
        timestamp: new Date().toISOString(),
        componentName: clickAction.componentName,
        action: clickAction.action,
      })
    }
  }

  noticeError(error: Error | HttpErrorResponse, traceId?: string) {
    if (this.newrelic) {
      if (error instanceof HttpErrorResponse) {
        this.newrelic.noticeError(error, {
          'x-trace-id': traceId,
        })
      } else {
        this.newrelic.noticeError(error)
      }
    }
  }
}
